<template>
  <div class="copyright">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <ul class="navigation-list">
            <li v-for="item in data.navigation.copyright" :key="item.id">
              <router-link :to="{ path: item.slug }">
                {{ getTranslation(item, 'title') }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-6">
          <div class="copy">
            {{ getSnippets('Copyright') }} © {{ new Date() | moment("YYYY") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Mixins */
import {Default} from '@mixins/Default';

/* Logic */
export default {
  name: 'Copyright',
  mixins: [Default],
  props: [
    'data'
  ]
}
</script>

<style lang="scss" scoped>
@import "@css/core/_variables.scss";
@import "@css/mixins/_breakpoints.scss";
@import "@css/mixins/_functions.scss";

.copyright {
  padding: 16px 0;
  background-color: $color-3;
  color: $white;

  // Mobile
  @include media-breakpoint-down(md) {
    text-align: center;
    font-size: 14px;
  }

  .copy {
    text-align: right;

    // Mobile
    @include media-breakpoint-down(md) {
      text-align: center;
    }
  }

  .navigation-list {
    list-style: none;
    margin: 0;
    padding: 0;

    // Mobile
    @include media-breakpoint-down(md) {
      margin-bottom: 4px;
    }

    li {
      display: inline-flex;
      margin-left: 8px;

      a {
        color: $white;

        // Mobile
        @include media-breakpoint-down(md) {
          font-weight: 700;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/App/Partials/Copyright.vue